/* eslint-disable */
import { DocumentResource, DocumentViewer } from '@cbojs/pdf-viewer';
import React, { MouseEvent, useEffect, useRef, useState } from 'react';
import { Accordion, Col, Container, Row } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { get2Pdfs, selectPdfsSlice } from '../../reducer/pdfSlice';
import { selectBlobsLists, selectFocusedBlobId, setFocusedBlobId } from '../../reducer/blobsSlice';

export default function ComparePdfsArea(): JSX.Element {
  const accordionBodyRef = useRef<null | HTMLDivElement>(null);
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const scrollToPdf = () => setTimeout(() => accordionBodyRef?.current?.scrollIntoView({ behavior: 'auto' }), 250);

  const dispatch = useAppDispatch();
  useEffect(() => {
    const get2PdfsPromise = dispatch(get2Pdfs());
    return () => get2PdfsPromise.abort();
  }, [dispatch]);

  const blobs = useAppSelector(selectBlobsLists);
  const pdfFiles = useAppSelector(selectPdfsSlice);
  const enDoc: DocumentResource = {};
  const deDoc: DocumentResource = {};
  if (pdfFiles.status === 'success') {
    const enData: string = pdfFiles.data.en;
    if (enData.startsWith('data:application/pdf;base64,')) enDoc.pdfBase64 = enData;
    else enDoc.pdfUrl = enData;

    const deData: string = pdfFiles.data.de;
    if (deData.startsWith('data:application/pdf;base64,')) deDoc.pdfBase64 = deData;
    else deDoc.pdfUrl = deData;
  }

  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const onClickScrollToBody = (e: MouseEvent<HTMLButtonElement>): void => {
    if (isExpanded) {
      dispatch(setFocusedBlobId(''));
    } else {
      scrollToPdf();
    }
    setIsExpanded(!isExpanded);
  };

  const focusedBlobId = useAppSelector(selectFocusedBlobId);
  useEffect(() => {
    if (focusedBlobId) {
      setIsExpanded(true);
      scrollToPdf();
    }
  }, [focusedBlobId]);

  return (
    <Accordion flush className="mt-2" activeKey={focusedBlobId ? '0' : undefined}>
      <Accordion.Item eventKey="0" className="bg-transparent">
        <Accordion.Button
          className="bg-transparent text-white"
          onClick={onClickScrollToBody}
        >
          {isExpanded
            ? 'Dokumentenansicht ausblenden'
            : 'Dokumentenansicht einblenden'}
        </Accordion.Button>
        <Accordion.Collapse eventKey="0" className="bg-secondary">
          <span>Übersetzungsfehler</span>
        </Accordion.Collapse>
        {/* <Accordion.Collapse eventKey="0" className="bg-danger">
          <span>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
            incididunt ut labore et dolore magna aliqua.
          </span>
        </Accordion.Collapse> */}
        <Accordion.Body className="bg-white px-0" ref={accordionBodyRef}>
          <Container>
            <style>
              {`
                .pdfPreviewer {
                  height: 500px;
                }
              `}
            </style>
            <Row className='flex-nowrap'>
              <Col xs={6}>
                <DocumentViewer
                  className="pdfPreviewer"
                  document={deDoc}
                  rendererProps={{
                    focusedBlobId: isExpanded ? focusedBlobId : undefined,
                    highlightedBlobIds: focusedBlobId ? [focusedBlobId] : [],
                    blobs: blobs.de,
                  }}
                />
              </Col>
              <Col xs={6}>
                <DocumentViewer
                  className="pdfPreviewer"
                  document={enDoc}
                  rendererProps={{
                    focusedBlobId: isExpanded ? focusedBlobId : undefined,
                    highlightedBlobIds: focusedBlobId ? [focusedBlobId] : [],
                    blobs: blobs.en,
                  }}
                />
              </Col>
            </Row>
          </Container>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
}
